import { useTranslation } from 'react-i18next'

export const ErrorToast = ({ mssg }) => {
  const { t } = useTranslation()

  return <div>{t(mssg)}</div>
}
